/**
 * QuestXR design tokens — the single source of truth for colors, typography,
 * and asset references shared across components. Ported 1:1 from the original
 * reference HTML so colors and font choices remain visually identical.
 */

export const colors = {
  gold: '#D4AF37',
  goldBright: '#FFD740',
  goldDark: '#cfa020',
  bronze: '#C19A6B',
  bgDeep: '#0a1a2a',
  bgElevated: '#14263b',
  bgCard: 'rgba(10,26,42,0.85)',
  bgFooter: '#060f1a',
  muted: 'rgba(255,255,255,0.5)',
  dim: 'rgba(255,255,255,0.3)',
  white: '#ffffff',
  whiteSoft: 'rgba(255,255,255,0.7)',
  whiteSofter: 'rgba(255,255,255,0.65)',
  whiteSoftest: 'rgba(255,255,255,0.55)',
} as const;

export const fonts = {
  heading: "'Cinzel', serif",
  body: "'Roboto', sans-serif",
} as const;

export const assets = {
  logo: '/assets/questxr-logo.png',
  pin: '/assets/pin.png',

  brpicon: '/assets/Chaosium-icon-black.png'
} as const;

export const externalLinks = {
  demo: 'https://qxrgame.com',
  brpInfo: 'https://www.chaosium.com/basicroleplaying/',
  backerKit: 'https://www.backerkit.com/c/projects/questxr/questxr-the-ttrpg-played-irl/pre-launch',
} as const;

/** Backward-compatible alias matching the original reference token names. */
export const C = colors;
